// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TimeSpan, TimeSpanFormat } from '@shared/utils/Time/TimeSpan';
import { Resources } from '@shared/localizations/Resources';
import { QuickTableEditingInfo } from '../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { DynProperty } from '@shared/commons/DynProperty';
import { DateTimeConvertor } from '@shared/utils/Time/DateTimeConvertor';
import { EventUtils } from '@shared/commons/UtilsClasses/EventUtils';
import { TradingEventType } from '@shared/commons/cache/Event/EventConstants';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { ThemeManager } from '../misc/ThemeManager';
export class EventItem extends BaseItem {
    constructor(ev, settings, dataCache) {
        super(settings);
        // TODO. Ugly. For table init.
        if (!ev)
            return;
        this.ev = ev;
        this.itemId = ev.Id;
        this.dataCache = dataCache;
        // this.sessionSettings = settings;
        this.QuickTableEditingInfoMap[3] = (function () {
            return new QuickTableEditingInfo(DynProperty.INFO_PICTURE);
        })();
    }
    getQuickTableCellForeground(column) {
        if ((column === 0 || column === 1 || column === 2 || column === 3 || column === 5) &&
            !isNullOrUndefined(this.ev)) {
            switch (this.ev.GetTradingEventType()) {
                case TradingEventType.MarginCall:
                case TradingEventType.Reject:
                case TradingEventType.Remove:
                    return ThemeManager.colors.negativeColor;
                case TradingEventType.Fill:
                case TradingEventType.Create:
                case TradingEventType.Modify:
                    return ThemeManager.colors.positiveColor;
                default:
                    return null;
            }
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
    GetColumnParams(columnIdx) {
        const par = EventItem.columnsParams[columnIdx];
        par.Hidden = par.DefaultHidden || Resources.isHidden(par.HeaderKey);
        return par;
    }
    ColumnCount() {
        return EventItem.columnsParams.length;
    }
    getColumnData(columnIdx) {
        /* TODO.
        if (column >= columnsParams.Length && customColumnFormattedValues.ContainsKey(column))
        {
            o = customColumnValues[column];
            return customColumnFormattedValues[column];
        }
        */
        const value = this.getColumnValue(columnIdx);
        let formattedValue = null;
        const ev = this.ev;
        switch (columnIdx) {
            case 1:
                formattedValue = DateTimeUtils.formatDate(value, 'DD.MM.YYYY  HH:mm:ss.SSS');
                break;
            case 4:
                formattedValue =
                    ev.Roundtrip > 0
                        ? TimeSpan.ToTimeSpanString(ev.Roundtrip, TimeSpanFormat.MilisecondSecondMinute)
                        : '';
                break;
            default:
                formattedValue = value.toString();
        }
        return new ColumnData(value, formattedValue);
    }
    getColumnValue(columnIdx) {
        /* TODO.
        if (column >= columnsParams.Length && customColumnValues.ContainsKey(column))
            return customColumnValues[column];
        */
        const ev = this.ev;
        switch (columnIdx) {
            case 0:
                return EventUtils.getEventTypeStr(ev.EventType);
            case 1:
                return DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(ev.DateTime);
            case 2: {
                const reportLocKey = 'reports.' + ev.Action;
                if (Resources.IsResourcePresent(reportLocKey)) {
                    return Resources.getResource(reportLocKey);
                }
                else {
                    return Resources.getResource(ev.Action);
                }
                // TODO. Looks like shit.
                // else return Resources.getResource(ev.action.Trim().Replace('\n', ' '), sessionSettings.Locale);
            }
            case 3:
                return ev.GetFormattedDescription();
            case 4:
                return ev.Roundtrip;
            default:
                return '';
        }
    }
}
EventItem.columnsParams = [
    new ColumnParams('panel.EventLog.Type', 100, QTAlignment.Left, TableTotalsVisibility.None, true, true),
    new ColumnParams('panel.EventLog.Date', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.EventLog.Action', 100, QTAlignment.Left, TableTotalsVisibility.None, true, true),
    new ColumnParams('panel.EventLog.Message', 50, QTAlignment.Left, TableTotalsVisibility.None, true, false)
    // new ColumnParams("panel.EventLog.Roundtrip", 40, QuickTableColumnType.COL_SIMPLE_NUMERIC, QuickTableAggregatesVisibility.None, true, false),
];
